module.exports = __webpack_public_path__ + "assets/edit-pen-source.cf38360e.svg";